import { FC } from "react";
import { Empty, EmptyProps } from "@pankod/refine-antd";

import { EmptyIcon } from "assets";

export const AppEmpty: FC<EmptyProps> = props => <Empty image={<EmptyIcon />} {...props} />;
